import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../static/css/ChildSafety.css';
import logo from '../static/images/images/a-logo-transperent.png';
class ChildSafety extends Component {
    constructor() {
        super();
        this.state = {};
    };
    render() {
        return (
            <div className="child-safety-container">
                <div className="animates-logo-container" style={{marginTop: "15px"}}><Link to="/"><img className="animates-logo" src={logo} alt="" /></Link></div>
                <div className="child-safety-title-container">
                    <h1 className="child-safety-title" ><u>Child Safety Standards</u></h1>
                </div>
                <div className="child-safety-section">

                    <p>
                        <b>Effective: May 27, 2026</b>
                        <br/><br/>
                        AniMates has zero tolerance for child sexual abuse and exploitation (CSAE) and child sexual abuse material (CSAM). The terms “AniMates,” “we,” “us,” and “our” include AniMates LLC and our affiliates. These Child Safety Standards explain how we work to prevent, detect, and respond to CSAE on our Platform, which means any website, application, or service we offer. These standards apply in addition to our Terms of Service, Community Guidelines, and Privacy Policy.
                    </p>

                    <h4>1. Our Commitment</h4>

                    <p>
                        We are committed to keeping our Platform free of child sexual abuse material and any content or conduct that sexualizes, exploits, or endangers minors. We prohibit, and act against, any use of the Platform to produce, store, share, solicit, or facilitate CSAE or CSAM. Violations result in immediate removal of the content, termination of the responsible account, and reporting to the appropriate authorities.
                    </p>

                    <h4>2. Age Requirement</h4>

                    <p>
                        AniMates is intended for adults aged 18 and older. The Platform is not directed to, and is not intended for use by, children or anyone under the age of 18. We do not knowingly permit anyone under 18 to create an account or use the Platform. If we become aware that a user is under 18, we will remove the account.
                    </p>

                    <h4>3. Prohibited Conduct And Content</h4>

                    <p>
                        The following are strictly prohibited on the Platform:
                        <br/><br/>
                        <i>Child sexual abuse material (CSAM) in any form, including images, videos, illustrations, or text;</i>
                        <br/><br/>
                        <i>Sexualization of minors, including grooming, solicitation, or any sexual or suggestive contact directed at a minor;</i>
                        <br/><br/>
                        <i>Sharing, requesting, or facilitating access to CSAE or CSAM;</i>
                        <br/><br/>
                        <i>Any other content or behavior that exploits or endangers minors.</i>
                    </p>

                    <h4>4. Reporting Child Safety Concerns</h4>

                    <p>
                        Users can report child safety concerns, including CSAE and CSAM, directly within the app. Every user profile, event, message thread, and piece of user-generated content includes a “Report” option that allows users to flag content or behavior that may violate these standards. Reports are reviewed by our team, and content related to child safety is prioritized.
                        <br/><br/>
                        You may also report concerns to us by email at <b>hello@animates.app</b>. We encourage anyone who becomes aware of CSAE or CSAM on the Platform to report it immediately.
                    </p>

                    <h4>5. Our Response And Legal Compliance</h4>

                    <p>
                        When we identify or receive a report of CSAE or CSAM, we act quickly to remove the content, disable and ban the responsible account, and preserve relevant information as required by law. AniMates complies with all applicable child safety laws and reports apparent child sexual abuse material to the National Center for Missing &amp; Exploited Children (NCMEC) and to other regional and national authorities as required. We cooperate with law enforcement investigations in accordance with applicable law.
                    </p>

                    <h4>6. Point Of Contact</h4>

                    <p>
                        We maintain a designated point of contact who is able to respond to questions about our CSAM prevention practices and compliance. If you have questions about these Child Safety Standards, or need to report a child safety concern, please contact us at <b>hello@animates.app</b>.
                    </p>

                    <h4>7. Revisions To These Standards</h4>

                    <p>
                        We may update these Child Safety Standards from time to time. When we do, we will publish the most current version on this page and revise the effective date above.
                    </p>

                </div>
            </div>
        );
    };
};
export default ChildSafety;
